module.exports = "/static/assets/83aad438a547a9dfd34794368ac3b643.png";